exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".marketing .text{margin:3rem 1rem;min-width:350px;max-width:650px;padding:2rem}.marketing .text h2,.marketing .text p{text-align:center}@media(min-width: 768px){.marketing .text h2,.marketing .text p{text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/Marketing/Marketing.scss
// module id = 7513
// module chunks = 13